import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-accent-dark text-cream pt-24 pb-12" data-id="element-71">
      <div className="max-w-[96rem] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        {/* Massive Footer Logo */}
        <div className="mb-20 border-b-4 border-cream/20 pb-12" data-id="element-73">
          <Link to="/" aria-label="Skybox home" className="block" data-id="element-74">
            <img src="https://cdn.magicpatterns.com/uploads/dyYxyrgmYYXhsadfoCQ9JQ/White_logo_-_no_background.png" alt="Skybox" className="h-48 sm:h-64 lg:h-80 xl:h-96 w-auto" data-id="element-75" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-20" data-id="element-76">
          {/* Brand Column */}
          <div className="lg:col-span-1" data-id="element-77">
            <p className="font-sans text-xl font-bold text-cream/80 max-w-sm mb-6 leading-snug" data-id="element-78">
              The business of sports. Essays, field notes, and the Skybox
              Podcast for the people building the next era of the industry.
            </p>
          </div>

          {/* Links Columns */}
          <div data-id="element-79">
            <h4 className="font-mono text-sm font-black tracking-widest uppercase text-cream/50 mb-8 pb-3 border-b-2 border-cream/20" data-id="element-80">
              Read
            </h4>
            <ul className="space-y-6 font-sans text-lg font-bold text-cream/80" data-id="element-81">
              <li data-id="element-82">
                <a href="/#essays" className="hover:text-cream transition-colors uppercase tracking-wide" data-id="element-83">
                  Essays
                </a>
              </li>
              <li data-id="element-84">
                <a href="/#field-notes" className="hover:text-cream transition-colors uppercase tracking-wide" data-id="element-85">
                  Field Notes
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="hover:text-cream transition-colors uppercase tracking-wide" data-id="element-87">
                  Archive
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-88">
            <h4 className="font-mono text-sm font-black tracking-widest uppercase text-cream/50 mb-8 pb-3 border-b-2 border-cream/20" data-id="element-89">
              Listen
            </h4>
            <ul className="space-y-6 font-sans text-lg font-bold text-cream/80" data-id="element-90">
              <li data-id="element-91">
                <a href="/#podcast" className="hover:text-cream transition-colors uppercase tracking-wide" data-id="element-92">
                  The Skybox Podcast
                </a>
              </li>
              <li data-id="element-93">
                <a href="#" className="hover:text-cream transition-colors uppercase tracking-wide" data-id="element-94">
                  Apple Podcasts
                </a>
              </li>
              <li data-id="element-95">
                <a href="#" className="hover:text-cream transition-colors uppercase tracking-wide" data-id="element-96">
                  Spotify
                </a>
              </li>
              <li data-id="element-97">
                <a href="#" className="hover:text-cream transition-colors uppercase tracking-wide" data-id="element-98">
                  YouTube
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-99">
            <h4 className="font-mono text-sm font-black tracking-widest uppercase text-cream/50 mb-8 pb-3 border-b-2 border-cream/20" data-id="element-100">
              Company
            </h4>
            <ul className="space-y-6 font-sans text-lg font-bold text-cream/80" data-id="element-101">
              <li data-id="element-102">
                <Link to="/about" className="hover:text-cream transition-colors uppercase tracking-wide" data-id="element-103">
                  About
                </Link>
              </li>
              <li data-id="element-104">
                <a href="#" className="hover:text-cream transition-colors uppercase tracking-wide" data-id="element-105">
                  Sponsorships
                </a>
              </li>
              <li data-id="element-106">
                <a href="#" className="hover:text-cream transition-colors uppercase tracking-wide" data-id="element-107">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t-4 border-cream/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-108">
          <p className="font-mono text-sm font-bold uppercase tracking-widest text-cream/60" data-id="element-109">
            © {new Date().getFullYear()} Skybox Media. All rights reserved.
          </p>
          <div className="flex space-x-8 font-mono text-sm font-bold uppercase tracking-widest text-cream/60" data-id="element-110">
            <a href="#" className="hover:text-cream transition-colors" data-id="element-111">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-cream transition-colors" data-id="element-112">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}